export type masterElementType = {
  elementId: string;
  elementType: string;
  elementName: string;
  elementValue: string;
  mode: number | undefined;
  dependency?: {
    basedOn: string;
    checkWith: string;
  };
};

export type invoiceTableType = {
  'Voucher No.': string;
  Dated: string;
  'Mode/Terms of Payment': string;
  'Reference No': string;
  'Other References': string;
  'Dispatched through': string;
  Destination: string;
  'Vendor Name': string;
  'Vendor Address': string;
  'GSTIN/UIN': string;
  'State Name': string;
  Code: string;
  'Terms of Delivery': string;
  'Asset to be Rented': any;
  'No of Units': string;
  'Rent per Day': string;
  'Total Rental Amount': string;
  'Total Rental Quantity': string;
};

export const invoiceSideContent = [
  'Voucher No.',
  'Dated',
  'Mode/Terms of Payment',
  'Reference No',
  'Other References',
  'Dispatched through',
  'Destination',
];

export const vendorDetails = ['Vendor Name', 'Vendor Address'];

export const additionalVendorDetails = ['GSTIN/UIN', 'State Name', 'Code'];

export const rentalAssetDetails = ['Asset to be Rented'];

export const number2text = (value: number) => {
  var fraction = Math.round(frac(value) * 100);
  var f_text = ' ';

  if (fraction > 0) {
    f_text = ' AND ' + convert_number(fraction) + ' PAISE ';
  }

  return convert_number(value) + f_text + 'ONLY';
};

const frac = (f: any) => {
  return f % 1;
};

const convert_number = (number: number) => {
  if (number < 0 || number > 999999999) {
    return 'NUMBER OUT OF RANGE!';
  }
  var Gn = Math.floor(number / 10000000); /* Crore */
  number -= Gn * 10000000;
  var kn = Math.floor(number / 100000); /* lakhs */
  number -= kn * 100000;
  var Hn = Math.floor(number / 1000); /* thousand */
  number -= Hn * 1000;
  var Dn = Math.floor(number / 100); /* Tens (deca) */
  number = number % 100; /* Ones */
  var tn = Math.floor(number / 10);
  var one = Math.floor(number % 10);
  var res = '';

  if (Gn > 0) {
    res += convert_number(Gn) + ' CRORE';
  }
  if (kn > 0) {
    res += (res === '' ? '' : ' ') + convert_number(kn) + ' LAKH';
  }
  if (Hn > 0) {
    res += (res === '' ? '' : ' ') + convert_number(Hn) + ' THOUSAND';
  }

  if (Dn) {
    res += (res === '' ? '' : ' ') + convert_number(Dn) + ' HUNDRED';
  }

  var ones = [
    '',
    'ONE',
    'TWO',
    'THREE',
    'FOUR',
    'FIVE',
    'SIX',
    'SEVEN',
    'EIGHT',
    'NINE',
    'TEN',
    'ELEVEN',
    'TWELVE',
    'THIRTEEN',
    'FOURTEEN',
    'FIFTEEN',
    'SIXTEEN',
    'SEVENTEEN',
    'EIGHTEEN',
    'NINETEEN',
  ];
  var tens = [
    '',
    '',
    'TWENTY',
    'THIRTY',
    'FOURTY',
    'FIFTY',
    'SIXTY',
    'SEVENTY',
    'EIGHTY',
    'NINETY',
  ];

  if (tn > 0 || one > 0) {
    if (!(res === '')) {
      res += ' AND ';
    }
    if (tn < 2) {
      res += ones[tn * 10 + one];
    } else {
      res += tens[tn];
      if (one > 0) {
        res += '-' + ones[one];
      }
    }
  }

  if (res === '') {
    res = 'zero';
  }
  return res;
};
